jQuery(function() {    

    var acSubmenu = document.querySelectorAll('.ac_submenu'); 
    for (var i = 0; i < acSubmenu.length; i++){    
        acSubmenu[i].style.display = 'none';        
    }
  
    var Accordion = function(el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        // Variables privadas
        var links = this.el.find('.ac_link');
      
        // Evento
        links.on('click', { el: this.el, multiple: this.multiple }, this.dropdown);
    };

    Accordion.prototype.dropdown = function(e) {
     
        var $el = e.data.el;
        $this = jQuery(this),
        $next = $this.next();
        $next.slideToggle();
        $this.parent().toggleClass('ac_open');
        // console.log($this);
        $this.attr('aria-expanded', 'true').next().attr('aria-hidden', 'false'); 

        if (!e.data.multiple) {
            $el.find('.ac_submenu').not($next).slideUp().parent().removeClass('ac_open');       
        }
    };	

    var accordion = new Accordion(jQuery('.ac_accordion'), false);
    //To make only 1 Panel open, keep second parameter false
});